const galleryItems = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20homemade%20pasta%20dish%20with%20fresh%20herbs%20and%20colorful%20vegetables%2C%20magazine%20style%20food%20photography%2C%20artistic%20plating%20on%20rustic%20wooden%20table%2C%20warm%20natural%20lighting%2C%20appetizing%20presentation%20with%20garnish%2C%20cheerful%20cooking%20class%20result&width=500&height=500&seq=gallery-pasta&orientation=squarish',
    title: '手作りパスタ',
    category: '洋食'
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20bento%20box%20with%20colorful%20seasonal%20ingredients%2C%20beautifully%20arranged%20home%20cooking%2C%20magazine%20editorial%20food%20styling%2C%20natural%20wooden%20background%2C%20artistic%20composition%20with%20fresh%20vegetables%20and%20rice&width=500&height=500&seq=gallery-bento&orientation=squarish',
    title: '季節のお弁当',
    category: '和食'
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Delicious%20homemade%20cake%20with%20fresh%20fruits%20and%20cream%2C%20magazine%20style%20dessert%20photography%2C%20beautiful%20cake%20decoration%2C%20pastel%20colors%2C%20inviting%20sweet%20treat%20on%20vintage%20plate%2C%20natural%20lighting&width=500&height=500&seq=gallery-cake&orientation=squarish',
    title: 'フルーツケーキ',
    category: 'デザート'
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20stir-fried%20vegetables%20and%20meat%20in%20wok%2C%20authentic%20Chinese%20home%20cooking%2C%20magazine%20food%20photography%2C%20vibrant%20fresh%20ingredients%2C%20appetizing%20Asian%20cuisine%2C%20rustic%20kitchen%20setting%20with%20natural%20light&width=500&height=500&seq=gallery-stirfry&orientation=squarish',
    title: '野菜炒め',
    category: '中華'
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Fresh%20homemade%20bread%20and%20pastries%20on%20wooden%20board%2C%20artisan%20baking%20results%2C%20magazine%20style%20bakery%20photography%2C%20warm%20golden%20crust%2C%20cozy%20kitchen%20atmosphere%2C%20natural%20ingredients%20visible&width=500&height=500&seq=gallery-bread&orientation=squarish',
    title: '手作りパン',
    category: 'パン'
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Healthy%20colorful%20salad%20bowl%20with%20fresh%20organic%20vegetables%2C%20nutritious%20meal%20preparation%2C%20magazine%20editorial%20food%20styling%2C%20vibrant%20greens%20and%20vegetables%2C%20clean%20eating%20concept%2C%20natural%20wooden%20background&width=500&height=500&seq=gallery-salad&orientation=squarish',
    title: 'ヘルシーサラダ',
    category: 'サラダ'
  }
];

export default function Gallery() {
  return (
    <section id="gallery" className="py-24 bg-gradient-to-b from-white to-orange-50/30 relative overflow-hidden">
      <div className="absolute top-20 left-10 w-24 h-24 opacity-10">
        <i className="ri-bowl-line text-orange-300 text-8xl"></i>
      </div>
      <div className="absolute bottom-20 right-10 w-24 h-24 opacity-10">
        <i className="ri-cup-line text-red-300 text-8xl"></i>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-white px-5 py-2.5 rounded-full shadow-lg mb-6 border-2 border-orange-300" style={{ borderStyle: 'dashed' }}>
            <i className="ri-gallery-line text-orange-500"></i>
            <span className="text-orange-600 font-medium" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
              Gallery
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Klee One", cursive' }}>
            レッスンの様子
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
            生徒さんが作った美味しそうな料理たち！
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryItems.map((item, index) => (
            <div 
              key={item.id}
              className="group cursor-pointer"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border-4 border-white" style={{ borderStyle: 'dashed' }}>
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-80 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <div className="inline-block bg-orange-400 text-white px-3 py-1 rounded-full text-xs font-medium mb-2" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
                    {item.category}
                  </div>
                  <h3 className="text-2xl font-bold text-white" style={{ fontFamily: '"Klee One", cursive' }}>
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6" style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}>
            あなたも美味しい料理を作ってみませんか？
          </p>
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-gradient-to-r from-orange-400 to-red-400 text-white px-10 py-4 rounded-full hover:shadow-xl transition-all whitespace-nowrap cursor-pointer font-bold text-lg shadow-lg"
            style={{ fontFamily: '"Zen Maru Gothic", sans-serif' }}
          >
            <i className="ri-sparkling-line mr-2"></i>
            今すぐ始める
          </button>
        </div>
      </div>
    </section>
  );
}
